var anime = window.anime;

var svg = document.getElementById("authorBlobSVGLarge");

if (svg) {
  var blob = svg.getElementById("authorBlobImageMaskPathLarge");

  var animation = anime({
    targets: blob,
    d: [
      {
        value: 'M86.355 8.79602C93.7959 13.8775 97.7738 24.4035 103.366 34.8326C108.935 45.2618 116.119 55.5941 116.867 66.4346C117.616 77.2993 111.907 88.6964 104.162 98.6416C96.3932 108.563 86.589 117.008 76.0828 117.806C65.5765 118.58 54.3917 111.708 44.1663 106.361C33.9175 101.013 24.628 97.2382 17.4679 90.5112C10.3312 83.8085 5.32374 74.1537 3.8964 63.9665C2.49245 53.7793 4.64517 43.0598 8.66982 32.8968C12.6945 22.7338 18.5677 13.1274 26.9212 8.50565C35.298 3.85971 46.1786 4.19848 57.0827 4.15008C67.9867 4.12589 78.9141 3.71453 86.355 8.79602Z'
      },
      {
        value: 'M89.6666 14.0467C100.09 20.6519 111.475 26.0715 116.511 35.1445C121.547 44.2417 120.212 56.9923 118.198 69.4767C116.207 81.937 113.536 94.1553 106.462 102.212C99.3877 110.269 87.9331 114.213 76.5488 116.947C65.188 119.681 53.9208 121.229 44.6213 117.624C35.2983 114.019 27.943 105.285 19.3462 96.6957C10.7494 88.1066 0.93458 79.7111 0.0678738 70.251C-0.822257 60.815 7.21234 50.3146 14.2163 41.3383C21.2202 32.3863 27.17 24.9343 34.6658 16.9259C42.1617 8.91747 51.1801 0.37675 60.4562 0.0138295C69.7089 -0.373285 79.2192 7.44159 89.6666 14.0467Z'
      },
    ],
    easing: 'easeInOutSine',
    direction: 'alternate',
    duration: 2 * 5000,
    loop: true,
  });
}
